import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import css from './blogPage.module.css';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { Page } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { Link } from 'react-router-dom';
import { getBlogPosts } from '../../util/contentful';

export const BlogPageComponent = props => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 8; // 4 per row x 2 rows = 8 blogs per page

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogPosts = await getBlogPosts();
        setBlogs(blogPosts);
      } catch (error) {
        console.error('Error loading blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // Calculate pagination
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Page>
      <div className={css.blogPageWrap}>
        <TopbarContainer
          className={css.blogPageTopbar}
          mobileRootClassName={css.mobileTopbar}
          desktopClassName={css.desktopTopbar}
        />
        <div className={css.blogPage}>
          <div className={css.blogPageHeader}>
            <h1 className={css.pageTitle}>Blog</h1>
            <p className={css.pageSubtitle}>Insights, tips, and stories from the world of vacation rentals</p>
          </div>

          {loading ? (
            <div className={css.loadingContainer}>
              <p>Loading blogs...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className={css.noBlogs}>
              <p>No blog posts found.</p>
            </div>
          ) : (
            <>
              <div className={css.blogsGrid}>
                {currentBlogs.map((blog) => (
                  <div key={blog.id} className={css.blogCard}>
                    <Link to={`/blog/${blog.slug}`} className={css.blogCardLink}>
                      <div className={css.blogCardImage}>
                        {blog.featuredImage ? (
                          <img 
                            src={`https:${blog.featuredImage}`} 
                            alt={blog.title} 
                          />
                        ) : (
                          <div className={css.placeholderImage}>No Image</div>
                        )}
                      </div>
                      <div className={css.blogCardContent}>
                        <h2 className={css.blogCardTitle}>{blog.title}</h2>
                        {blog.subtitle && (
                          <p className={css.blogCardSubtitle}>{blog.subtitle}</p>
                        )}
                        <span className={css.readMoreLink}>Read More →</span>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className={css.paginationContainer}>
                  <button
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                    className={`${css.paginationBtn} ${css.paginationArrow}`}
                  >
                    ← Previous
                  </button>

                  <div className={css.paginationNumbers}>
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => paginate(pageNumber)}
                          className={`${css.paginationBtn} ${
                            currentPage === pageNumber ? css.paginationActive : ''
                          }`}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}
                  </div>

                  <button
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className={`${css.paginationBtn} ${css.paginationArrow}`}
                  >
                    Next →
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        <FooterContainer footerClassName={css.footer} />
      </div>
    </Page>
  );
};

const mapStateToProps = state => {
  return {};
};

const BlogPage = compose(
  connect(mapStateToProps)
)(BlogPageComponent);

export default BlogPage;